
<mat-toolbar  data-testid="header-toolbar">
  <button *ngIf="isMobileOrTablet && !sidenavOpened" mat-icon-button aria-label="Open sidenav" class="menu-btn" (click)="openSidenav()" data-testid="open-sidenav-menu">
		<mat-icon>menu</mat-icon>
	</button>
	<header class="header-ui">
    <div class="header-left" data-testid="title-search-container">
			<!-- <span class="header-title">{{ title | translate }}</span> -->
      <div [ngClass]="{'search-pill': true, 'with-input': !isMobileOrTablet, 'icon-only': isMobileOrTablet}" data-testid="search-input-container">
        <ng-container *ngIf="!isMobileOrTablet; else mobileSearchIcon">
          <app-tooltip>
            <img src="assets/images/search_icon.svg" alt="Search icon" aria-hidden="true">
          <input #searchInput class="search-input" type="text" placeholder="Search portal…" data-testid="search-input" (input)="onSearch($event)" aria-label="Search portal" />
                  </app-tooltip>
        </ng-container>
        <ng-template #mobileSearchIcon>
          <app-tooltip>
            <img src="assets/images/search_icon.svg" alt="Search icon" aria-hidden="true">
          <input #searchInput class="search-input" type="text" placeholder="Search portal…" data-testid="search-input" (input)="onSearch($event)" aria-label="Search portal" />
          </app-tooltip>
        </ng-template>
      </div>
		</div>  
    <div class="header-right" data-testid="header-userinfo-container">
				<button
          mat-icon-button
          class="button_23-1009 tiny-badge"
          aria-label="Notifications"
          data-testid="notifications-button"
          [matMenuTriggerFor]="notificationsMenu"
          [matBadge]="unreadNotificationCount"
          [matBadgeHidden]="unreadNotificationCount === 0"
          matBadgeColor="warn"
          matBadgeSize="small"
        >
					<img src="assets/images/noti.svg" class="notification_icon" alt="Notification icon" aria-hidden="true" />
				</button>

        <mat-menu #notificationsMenu="matMenu" xPosition="before" class="header-notification-menu" data-testid="notifications-menu">
          <div class="notifications-panel" data-testid="notifications-panel">
            <div class="notifications-header" data-testid="notifications-header">
              <div class="notifications-title-wrap">
                <span class="notifications-title">Notifications</span>
              </div>
              <span class="notifications-unread-pill" *ngIf="unreadNotificationCount > 0">{{ unreadNotificationCount }} new</span>
            </div>

            <div class="notifications-list scroll-container" data-testid="notifications-list" *ngIf="notifications.length; else noNotificationsTemplate">
              <button
                mat-menu-item
                class="notification-item"
                *ngFor="let notification of notifications"
                (click)="onNotificationClick(notification)"
                [class.read]="notification.isRead"
                [class.unread]="!notification.isRead"
              >
                <div class="notification-icon-avatar" [ngClass]="'icon-' + notification.kind" aria-hidden="true">
                  <mat-icon class="icon_no_margin">{{ getNotificationIcon(notification.kind) }}</mat-icon>
                </div>
                <div class="notification-content">
                  <div class="notification-top-row">
                    <span class="notification-title">{{ notification.title }}</span>
                    <span class="notification-dot" *ngIf="!notification.isRead" aria-hidden="true"></span>
                  </div>
                  <span class="notification-message">{{ notification.message }}</span>
                  <div class="notification-meta-row">
                    <span class="notification-ticket-badge" *ngIf="notification.serviceRequestTicket">{{ notification.serviceRequestTicket }}</span>
                    <span class="notification-time">{{ notification.timeAgo }}</span>
                  </div>
                </div>
              </button>
            </div>

            <ng-template #noNotificationsTemplate>
              <div class="empty-notifications" data-testid="empty-notifications">
                <mat-icon aria-hidden="true" class="empty-notifications-icon">notifications_none</mat-icon>
                No notifications available
              </div>
            </ng-template>
          </div>
        </mat-menu>
			<mat-divider class="container_23-1008" vertical></mat-divider>
			 <ng-container *ngIf="currentUser">
    <button mat-button [matMenuTriggerFor]="userMenu" class="button_23-1015" data-testid="user-info-shell" aria-label="">
      <mat-card class="button_23-1015" data-testid="user-info-card">
        <mat-list dense class="container_23-1016">
          <mat-list-item disableGutters class="text_23-1017">
            <span matLine class="text-james-anderson_23-1018" [title]="currentUser.name || ''">{{ currentUser.name }}</span>
          </mat-list-item>
          <mat-list-item disableGutters class="text_23-1019">
            <span matLine class="text-administrator_23-1020">{{ currentUser.role }}</span>
          </mat-list-item>
        </mat-list>
        <mat-card class="container_23-1021">
          <div mat-card-avatar class="image--user-_23-1022">
            <img class="user_image" src="assets/images/User_image.jpg" alt="closed">
          </div>
        </mat-card>
        <img class="icon_23-1023" src="assets/images/downuser_arrow.svg" alt="closed">
      </mat-card>
    </button>

    <mat-menu #userMenu="matMenu" xPosition="before" class="mat-menu_" data-testid="logout-card">
      <button mat-menu-item data-testid="profile-button">
        <app-tooltip>
          <mat-icon>people</mat-icon>
          <span>Profile</span>
        </app-tooltip>
      </button>
      <button mat-menu-item data-testid="settings-button">
        <app-tooltip>
          <mat-icon>settings</mat-icon>
          <span>Settings</span>
        </app-tooltip>
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="logout()" data-testid="logout-button">
        <mat-icon>exit_to_app</mat-icon>
        <span class="logout-title">Log out</span>
      </button>
    </mat-menu>
  </ng-container>
		</div>
	</header>
</mat-toolbar>
